import Ajax from "@/lib/ajax";

export default {
  /**
   * 获取会员标签列表
   */
  getVipTagList(pageSize: number, currentPage: number) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    };
    return Ajax.get(`/api/Vip/VipTag`, {
      params: params
    });
  },

  /**
   * 获取全部标签列表
   */
  getAllTagList(isAutoTag?: boolean) {
    let params = {
      IsAutoTag: isAutoTag
    };
    return Ajax.get(`/api/Vip/VipTag/list`,{
      params: params
    });
  },

  /**
   * 更新导购可见
   */
  updateActive(id: string) {
    return Ajax.put(`/api/Vip/VipTag/active?id=${id}`);
  },

  /**
   * 获取指定id的标签
   * @param id
   */
  getVipTagDetail(id: string) {
    return Ajax.get(`/api/Vip/VipTag/${id}`);
  },

  /**
   * 批量删除标签
   * @param ids
   */
  deleteVipTag(ids: string[]) {
    const text = ids.join("&ids=");
    return Ajax.delete(`/api/Vip/VipTag?ids=${text}`);
  },

  /**
   * 创建/更新会员标签
   * @param obj
   * @param id
   */
  createOrUpdate(obj: object) {
    let ajaxType = obj["id"] ? "put" : "post";
    let ajaxUrl = "/api/Vip/VipTag";
    return Ajax[ajaxType](ajaxUrl, obj);
  },

  /**
   * 分配标签
   * @param tagIds
   * @param userIds
   */
  VipTagUser(tagIds: string[], userIds: string[]) {
    return Ajax.post(`/api/Vip/VipTagUser`, {
      tagIds: tagIds,
      userIds: userIds
    });
  },
  /**
   * 导出会员列表
   */
  exportBrokerageReportFile(MaxResultCount: number, currentPage: number, BeginTime?: string, EndTime?: string) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      BeginTime,
      EndTime
    }
    return Ajax.get('/api/Vip/VipInfos/exportVipFile', {
      params: params,
      responseType: "blob"
    })
  }
};
